import { useContext } from 'react';
import { kcSanitize } from 'keycloakify/lib/kcSanitize';
import type { PageProps } from 'keycloakify/login/pages/PageProps';
import { LinkText } from '@bankiru/ui-kit/components/Link/LinkText';

import { ThemeContext } from '../../../context/ThemeContextWrapper';
import { isMobilePlatform } from '../../../helpers/isMobilePlatform';
import type { I18n } from '../../i18n';
import type { KcContext } from '../../KcContext';

export default function Error(props: PageProps<Extract<KcContext, { pageId: 'error.ftl' }>, I18n>) {
	const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

	const { message, client, skipLink } = kcContext;

	const { platform, isIOS } = useContext(ThemeContext);

	const { msg } = i18n;

	const isWebview = isMobilePlatform(platform) || isIOS;

	return (
		<Template
			kcContext={kcContext}
			i18n={i18n}
			doUseDefaultCss={doUseDefaultCss}
			classes={classes}
			displayMessage={false}
			headerNode={msg('errorTitle')}
		>
			<div id="kc-error-message">
				<p
					className="instruction"
					dangerouslySetInnerHTML={{ __html: kcSanitize(message.summary) }}
				/>
				{!isWebview && !skipLink && client !== undefined && client.baseUrl !== undefined && (
					<p>
						<LinkText skin="blue" href={client.baseUrl}>
							{msg('backToApplication')}
						</LinkText>
					</p>
				)}
			</div>
		</Template>
	);
}
